<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="24">
          <a-col :span="3">
            <a-form-item label="年级">
              <j-dict-select-tag
                placeholder="请选择年级"
                v-model="queryParam.gradeId"
                dictCode="school_grade,grade_name,id,0=delete_flag order by sort_order"
                style="width: 100%"
                allowClear
                @change="handleGradeChange"
                @clear="handleGradeChange"
                @input="handleGradeChange"
              ></j-dict-select-tag>
            </a-form-item>
          </a-col>
          <a-col :span="3">
            <a-form-item label="班级">
              <j-dict-select-tag
                :disabled="!queryParam.gradeId"
                placeholder="请选择班级"
                v-model="queryParam.classId"
                :dictCode="
                  'school_class,name,id,grade_id=' + (!queryParam.gradeId ? -1 : queryParam.gradeId)
                "
                :async="true"
                style="width: 100%"
              ></j-dict-select-tag>
            </a-form-item>
          </a-col>
          <a-col :span="4">
            <a-form-item label="学生名称">
              <a-input v-model="queryParam.studentName" />
            </a-form-item>
          </a-col>
          <a-col :span="4">
            <a-form-item label="处理状态">
              <a-select v-model="queryParam.dealType" allowClear>
                <a-select-option value="0">未处理</a-select-option>
                <a-select-option value="1">已处理</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="5">
            <a-form-item label="时间范围">
              <a-range-picker :value="rangeDate" @change="onRangeChange" />
            </a-form-item>
          </a-col>

          <a-col :span="4">
            <span style="float: left; overflow: hidden" class="table-page-search-submitButtons">
              <a-button type="primary" @click="loadData(1)" icon="search">查询</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button
        type="primary"
        icon="download"
        @click="handleExportXlss('学生提醒清单')"
        :loading="exportXlsLoading"
      >
        导出
      </a-button>
    </div>

    <!-- table区域-begin -->
    <div>
      <a-table
        ref="table"
        size="middle"
        :scroll="{ x: true }"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :loading="loading"
        :pagination="ipagination"
        class="j-table-force-nowrap"
        @change="handleTableChange"
      />
    </div>
  </a-card>
</template>

<script>
import '@/assets/less/TableExpand.less'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import { getDictCodeData } from '@/utils/util'

const setBorderStyle = (style = { borderRight: '1px solid #FFDEA1' }) => {
  return {
    style,
  }
}

export default {
  name: 'StudentWarnList',
  mixins: [JeecgListMixin],
  data() {
    return {
      loading: false,
      queryParam: {},
      rangeDate: [],
      // 表头
      columns: [
        {
          title: '#',
          dataIndex: '',
          key: 'rowIndex',
          width: 40,
          align: 'center',
          customRender: function (t, r, index) {
            return parseInt(index) + 1
          },
        },
        {
          title: '班级',
          align: 'center',
          width: 150,
          dataIndex: 'className',
        },
        {
          title: '学生',
          align: 'center',
          width: 150,
          dataIndex: 'name',
        },
        {
          title: '提醒内容',
          align: 'center',
          width: 100,
          dataIndex: 'comment',
          customRender: (_, record) => {
            const comment = record.comment.replace('该生为情绪内敛型', '')
            return comment.length >= 25 ? (
              <a-tooltip>
                <template slot="title">{comment}</template>
                {comment.substring(0, 25) + '...'}
              </a-tooltip>
            ) : (
              comment
            )
          },
        },
        {
          title: '提醒时间',
          align: 'center',
          width: 150,
          dataIndex: 'warnDate',
          // customHeaderCell: () => {
          //   return setBorderStyle()
          // },
          // customCell: () => {
          //   return setBorderStyle()
          // },
        },
        {
          title: '当前环节',
          align: 'center',
          width: 150,
          dataIndex: 'process_dictText',
          customHeaderCell: () => {
            return setBorderStyle()
          },
          customCell: () => {
            return setBorderStyle()
          },
        },
        {
          title: '班主任',
          // 设置表头单元格样式
          customHeaderCell: () => {
            return setBorderStyle({ borderRight: '1px solid #93DFFC' })
          },
          children: [
            {
              title: '问题原因',
              dataIndex: 'careReason_dictText',
              align: 'center',
              width: 150,
            },
            {
              title: '干预措施',
              dataIndex: 'intervention_dictText',
              align: 'center',
              width: 200,
            },
            {
              title: '效果反馈',
              dataIndex: 'effectFeedback_dictText',
              align: 'center',
              width: 150,
            },
            // {
            //   title: '是否反馈校领导',
            //   dataIndex: 'careFeedbackFlag',
            //   align: 'center',
            //   width: 150,
            // },
            // {
            //   title: '校领导名称',
            //   dataIndex: 'careLeaderName',
            //   align: 'center',
            //   width: 150,
            // }, 
            {
              title: '具体情况说明',
              dataIndex: 'careSpecificInstructions',
              align: 'center',
              width: 400,
            },
            {
              title: '班主任名称',
              align: 'center',
              dataIndex: 'headteacherName',
              width: 150,
              customRender: (_, record) => {
                return record.headteacherName
              },
            },
            {
              title: '班主任处理时间',
              align: 'center',
              width: 150,
              dataIndex: 'headteacherDealTime',
              customHeaderCell: () => {
                return setBorderStyle({ borderRight: '1px solid #93DFFC' })
              },
              customCell: () => {
                return setBorderStyle({ borderRight: '1px solid #93DFFC' })
              },
            },
          ],
        },
        {
          title: '心理老师',
          customHeaderCell: () => {
            return setBorderStyle({ borderRight: '1px solid #FFDEA1' })
          },
          customCell: () => {
            return setBorderStyle({ borderRight: '1px solid #FFDEA1' })
          },
          children: [
            {
              title: '辅导时间',
              dataIndex: 'tutoringTime',
              align: 'center',
              width: 150,
            },
            {
              title: '辅导类型',
              dataIndex: 'tutoringType_dictText',
              align: 'center',
              width: 150,
            },
            {
              title: '辅导方法',
              dataIndex: 'tutoringMethod_dictText',
              align: 'center',
              width: 150,
            },
            {
              title: '问题原因',
              dataIndex: 'tutoringReason_dictText',
              align: 'center',
              width: 150,
            },
            {
              title: '下一步措施',
              dataIndex: 'nextIntervention_dictText',
              align: 'center',
              width: 150,
            },
            {
              title: '效果反馈',
              dataIndex: 'tutoringEffectFeedback_dictText',
              align: 'center',
              width: 150,
            },
            {
              title: '危机等级',
              dataIndex: 'crisisLevel_dictText',
              align: 'center',
              width: 150,
            },
            {
              title: '是否反馈校领导',
              dataIndex: 'feedbackFlag',
              align: 'center',
              width: 150,
            },
            {
              title: '校领导名称',
              dataIndex: 'leaderName',
              align: 'center',
              width: 150,
            },
            {
              title: '具体情况说明',
              align: 'center',
              width: 400,
              dataIndex: 'tutorSpecificInstructions',
            },
            {
              title: '心理老师名称',
              align: 'center',
              width: 150,
              dataIndex: 'psychologistName',
            },
            {
              title: '心理老师处理时间',
              align: 'center',
              dataIndex: 'psychologistDealTime',
              customHeaderCell: () => {
                return setBorderStyle({ borderRight: '1px solid #FFDEA1' })
              },
              customCell: () => {
                return setBorderStyle({ borderRight: '1px solid #FFDEA1' })
              },
            },
          ],
        },
        // {
        //   title: '处理内容',
        //   align: 'center',
        //   dataIndex: 'dealContent',
        // },
        // {
        //   title: '标签',
        //   align: 'center',
        //   dataIndex: 'comment',
        //   customRender: function (t, r, index) {
        //     if (t.indexOf('情绪内敛型') > -1) {
        //       return '情绪内敛型'
        //     } else {
        //       return ''
        //     }
        //   },
        // },
        // {
        //   title: '当前环节',
        //   align: 'center',
        //   dataIndex: 'process',
        //   customHeaderCell: () => {
        //     return setBorderStyle({ borderLeft: '1px solid #FFDEA1' })
        //   },
        //   customCell: () => {
        //     return setBorderStyle({ borderLeft: '1px solid #FFDEA1' })
        //   },
        // },
      ],
      url: {
        list: '/aigoes/schoolWarnRecord/studentWarnList',
        exportXlsUrl: '/aigoes/schoolWarnRecord/exportXls',
      },
    }
  },
  created() {},
  methods: {
    onRangeChange(dates, dateString) {
      this.rangeDate = dates

      this.queryParam.beginDate = dateString[0]
      this.queryParam.endDate = dateString[1]

      this.loadData(1)
    },
    handleGradeChange() {
      this.$set(this.queryParam, 'classId', '')
    },
    handleExportXlss(title) {
      this.handleExportXls(title, this.queryParam)
    },
  },
}
</script>
<style scoped lang="less">
@import '~@assets/less/common.less';
// 只限制其他措施那一行的宽度,目前太宽了
.j-table-force-nowrap /deep/.ant-table .ant-table-tbody tr td{
  white-space: break-spaces;
}
</style>
